import { create } from "zustand";

export interface FlyingCompareItem {
  id: string;
  image?: string;
  from: { x: number; y: number; size: number };
}

interface CompareUiState {
  compareAnchor: HTMLElement | null;
  flyingItems: FlyingCompareItem[];

  setCompareAnchor: (el: HTMLElement | null) => void;

  /**
   * Play the fly-to-compare animation from `source` toward the bottom
   * compare bar. `source` can be an HTMLElement or a DOMRect-like.
   */
  playFlyToCompare: (args: {
    source: HTMLElement | DOMRect | null;
    image?: string;
  }) => void;

  _removeFlyingItem: (id: string) => void;
}

export const FLY_COMPARE_ANIMATION_MS = 650;

export const useCompareUiStore = create<CompareUiState>((set, get) => ({
  compareAnchor: null,
  flyingItems: [],

  setCompareAnchor: (el) => set({ compareAnchor: el }),

  playFlyToCompare: ({ source, image }) => {
    const rect =
      source instanceof HTMLElement
        ? source.getBoundingClientRect()
        : (source as DOMRect | null);
    if (!rect) return;

    const size = Math.min(rect.width, rect.height, 96);
    const item: FlyingCompareItem = {
      id: `fly-compare-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
      image,
      from: {
        x: rect.left + rect.width / 2 - size / 2,
        y: rect.top + rect.height / 2 - size / 2,
        size,
      },
    };
    set((s) => ({ flyingItems: [...s.flyingItems, item] }));

    window.setTimeout(
      () => get()._removeFlyingItem(item.id),
      FLY_COMPARE_ANIMATION_MS + 50,
    );
  },

  _removeFlyingItem: (id) =>
    set((s) => ({ flyingItems: s.flyingItems.filter((i) => i.id !== id) })),
}));
